import styled from '@emotion/styled'

const Card = styled.div`
    border-radius: 5px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    cursor: pointer;
`

const CardContent = styled.div`
    overflow: hidden;
`

const CardExtra = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 2.5rem;
    border-top: 1px solid rgba(34, 36, 38, 0.15);
    
    a {
        display: flex;
        column-gap: .5rem;
    }
`

export { Card, CardContent, CardExtra }
